import type { User } from '../domain/user'

export class CreateUserAdapter {
    static toDomain(data: {
        name: string
        email: string
        warehouse_id: number
        role_id: number
        password: string
        confirm_password?: string
    }): User {
        return {
            name: data.name,
            email: data.email,
            warehouseId: data.warehouse_id,
            roleId: data.role_id,
            password: data.password,
            confirmPassword: data.confirm_password,
        }
    }
}

export { CreateUserAdapter as default }
